import  axios from 'axios';

const instance = axios.create({
  //  withCredentials: true,
    baseURL: `https://${process.env.REACT_APP_NAME_SITE_API}/local/rest/organza/api/`,
    headers:{

    }
});
const instance2 = axios.create({
  //  withCredentials: true,
   //  baseURL: `https://organza.boltua.ru/local/rest/organza/api/`,
    baseURL: `https://${process.env.REACT_APP_NAME_SITE_API}/local/rest/organza/api/`,
    headers:{

    }
});

export const filtrSmartCatalogAPI = {
    getProperty(parametrs="")  {
   
        return  instance.get( `getProperty/${parametrs}`,{
            "Access-Control-Allow-Origin": "*",
            'Content-Type': 'application/json'
        })
          .then(response => {
             return  response.data
          });
      },
}

export const CatalogItemsAPI = {
    CatalogItems(pageSize="",currentPage="",parametrs="")  {
   
        return  instance.get( `?countItems=${pageSize}&page=${currentPage}${parametrs}`,{
            "Access-Control-Allow-Origin": "*",
            'Content-Type': 'application/json'
        })
          .then(response => {
             return  response.data
          });
      },
      CatalogItemsFish(p_id,pp_id,price,name,url,patchImgValue)  {
        const articleFish = `p_id=${p_id}&pp_id=${pp_id}&p=${price}&name=${name}&dpu=/${url}/&patchImgValue=${patchImgValue}`;
        return  instance2.post( `basket/wishlist/`,articleFish,{
           "Access-Control-Allow-Origin": "*"
        })
          .then(response => {
             return  response.data
          });
      },
      BasketIdItemsFish(BasketIdItems)  {
        const articleFish = `basketIdItems=${BasketIdItems}`;
        return  instance2.post( `basket/wishlist/`,articleFish,{
           "Access-Control-Allow-Origin": "*"
        })
          .then(response => {
             return  response.data
          });
      },
      BasketIdItem(BasketIdItem,quantity=1)  {
        const articleFish = `basketIdItem=${BasketIdItem}&quantity=${quantity}`;
        return  instance2.post( `basket/`,articleFish,{
           "Access-Control-Allow-Origin": "*"
        })
          .then(response => {
             return  response.data
          });
      },
      BasketIdItemsFastOrder(PRODUCT_ID,delivery,NAME,EMAIL,PHONE,COMMENT,count = 1)  {
        const fastOrder = `PRODUCT_ID=${PRODUCT_ID}&delivery=${delivery}&NAME=${NAME}&EMAIL=${EMAIL}&PHONE=${PHONE}&COMMENT=${COMMENT}&count=${count}`;
        return  instance2.post( `fastorder/`,fastOrder,{
           "Access-Control-Allow-Origin": "*"
        })
          .then(response => {
             return  response.data
          });
      },
}